import React from 'react';
import { Button, Spin, notification } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { downloadBcpReport } from '../../store/reducers/reportsSlice';
import { rejectedApiMessage } from '../../utilities/CommonHelper';
import './bcpReportContainer.css';

const BCPReportContainer: React.FC = () => {
  const dispatch = useDispatch();
  const reportsData = useSelector((state: any) => state.reports);

  const handleExport = () => {
    dispatch(downloadBcpReport()).then((response: any) => {
      if (response.type === 'reports/downloadBcpReport/fulfilled') {
        notification.success({
          message: 'BCP Report Requested',
          description:
            'The BCP report has been generated and will be sent to your registered email address shortly.',
          duration: 6,
        });
      } else {
        rejectedApiMessage(response.payload);
      }
    });
  };

  return (
    <Spin spinning={reportsData?.loading} tip="Requesting report…">
      <div className="bcp-report-wrapper">
        <div className="bcp-report-header row">
          <h2 className="col-lg-6 col-sm-12 page-heading">BCP Report</h2>
        </div>

        <div className="bcp-report-card">
          <div className="bcp-report-card__icon">
            <MailOutlined style={{ fontSize: 56, color: '#034ea2' }} />
          </div>
          <h3 className="bcp-report-card__title">Export BCP Report</h3>
          <p className="bcp-report-card__description">
            Click the button below to generate the BCP report. The report will
            be compiled and sent to your registered email address.
          </p>
          <Button
            type="primary"
            size="large"
            icon={<MailOutlined />}
            onClick={handleExport}
            disabled={reportsData?.loading}
            style={{
              borderRadius: '0',
              backgroundColor: '#034ea2',
              font: 'normal normal 600 12px / 16px Nunito Sans',
              minWidth: '200px',
            }}
          >
            Export &amp; Send to Email
          </Button>
        </div>
      </div>
    </Spin>
  );
};

export default BCPReportContainer;
